import Link from "next/link";
import { useState, useEffect } from "react";
import { ChevronLeft, Minus, Plus, Trash2 } from "lucide-react";
import LoadingCounter from "@/components/LoadingCounter";

const Counter = ({
    min = 1,
    max = 10,
    removeHandler,
    remove_from_cart_loading = false,
    quantity = 0,
    onChange,
    loading = false,
    size = "default",
    isOutOfStock = false,
}) => {
    const [count, setCount] = useState(quantity);

    useEffect(() => {
        setCount(quantity);
    }, [quantity]);

    const isSm = size === "sm";
    const isDeleting = remove_from_cart_loading && count <= min;
    const isDisabled = loading || isDeleting;

    const increase = () => {
        if (count >= max || isDisabled || isOutOfStock) return;

        const newValue = count + 1;
        setCount(newValue);
        onChange?.(newValue);
    };

    const decrease = (e) => {
        if (isDisabled) return;

        if (count <= min) {
            removeHandler?.(e);
            return;
        }

        const newValue = count - 1;
        setCount(newValue);
        onChange?.(newValue);
    };

    return (
        <div
            className={`counter-component flex items-center justify-between gap-2 ${isSm ? "w-fit" : "w-full"
                }`}
        >
            <div
                className={`flex items-center justify-between bg-jmt-white border border-jmt-neutral-300 rounded-md overflow-hidden
                    ${isSm ? "h-11 w-[132px]" : "h-auto w-auto"}`}
            >
                <button
                    onClick={increase}
                    disabled={count >= max || isDisabled || isOutOfStock}
                    className={`flex items-center justify-center transition-colors
                        ${isOutOfStock ? "text-jmt-neutral-300 cursor-not-allowed" : "text-jmt-neutral-800 cursor-pointer hover:bg-neutral-50"}
                        ${(!isOutOfStock && (count >= max || isDisabled)) ? "opacity-40" : ""}
                        ${isSm ? "w-10 h-full" : "px-3 py-2"}`}
                >
                    <Plus size={isSm ? 18 : 22} />
                </button>

                <span
                    className={`font-bold text-center flex items-center justify-center
                    ${isOutOfStock ? "text-jmt-neutral-400" : "text-jmt-main"}
                    ${isSm ? "flex-1 text-sm" : "px-3 w-10 text-base"}`}
                >
                    {loading || isDeleting ? (
                        <LoadingCounter width="28px" className="h-[5px]!" />
                    ) : (
                        count
                    )}
                </span>

                <button
                    onClick={isOutOfStock ? removeHandler : decrease}
                    disabled={!isOutOfStock && isDisabled}
                    className={`flex items-center justify-center transition-colors
                        ${isOutOfStock ? "text-jmt-neutral-800 cursor-pointer hover:bg-neutral-50" : "text-jmt-neutral-800 cursor-pointer hover:bg-neutral-50"}
                        ${(!isOutOfStock && isDisabled) ? "opacity-40" : ""}
                        ${isSm ? "w-10 h-full" : "px-3 py-2"}`}
                >
                    {(count <= min || isOutOfStock) ? (
                        <Trash2 size={isSm ? 18 : 22} />
                    ) : (
                        <Minus size={isSm ? 18 : 22} />
                    )}
                </button>
            </div>

            {!isSm && (
                <Link
                    href="/cart"
                    className="link-to-cart flex items-start justify-between text-jmt-primary-800 hover:text-jmt-primary-900 text-xs font-bold"
                >
                    <span> سبد خرید </span>
                    <ChevronLeft size={16} className="shrink-0" />
                </Link>
            )}
        </div>
    );
};

export default Counter;
